import { Injectable } from "@angular/core";
import { URLS } from '../../../config/api.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import moment from 'moment';
import { catchError, map } from 'rxjs/operators';
import { environment } from "../../../environments/environment";
import { CommonService } from "../../helpers/common.service";
import { CustomEncryption } from "../../../config/custom-encrypt";
import { StorageServiceAAA } from "../../helpers/aaa-storage.service";

@Injectable()
export class ShareReportService {

	private clientPanNo = URLS.clientPanNo;
	private tradeListing = URLS.tradeListing
	private settlement = URLS.settlement;

	private unRealizedPL = URLS.unRealizedPL
	private realizedPL = URLS.realizedPL
	private zentechContractNotes = URLS.zentechContractNotes

	private downloadReport = URLS.reportDownload
	private dpHoldingStatement = URLS.dpHoldingStatement
	private mfRejectionData = URLS.mfRejectionData
	private ExchangeCertificate = URLS.exchangeCertificateURL

	private userActivationToken = URLS.userActivationToken
	private modificationStatus = URLS.modificationStatus

	// public options: any ;
	// public panNoCookieKEY: any = environment['panNoCookieKEY'];
	// private nativeHeaders: any = environment['nativeHeaders'];
	// private nativePanNoHeaders: any = environment['nativePanNoHeaders']
	private mfReport: any = URLS.mfAccountReportDownload
	// public mfAccountHeaders: any = environment['mfReportDownloadHeader'];
	// private gatewaySubscriptionKey:any
	private commodityrealtimereport: any = URLS['commodityrealtimereport']
	// private globalCheckSumkey : any;

	env:any;
	userActivationandModificationStatusParams: any;
	mfCommonVid: any;
	constructor(private httpClient: HttpClient,
		private nativeHttp: HTTP,
		private commonService: CommonService,
		private ciphetText: CustomEncryption,private storage: StorageServiceAAA) {
		
	}


    
    public getClientPanNo(cookievalue: any, clientID: any): Observable<{}> {
		let params = {"objHeader":{"VID":"mfCommonVid","AppName":this.clientPanNo.appName,"AppVersion":"1.0.26.0"},"Value":clientID}
	
			let obj = {
						'Ocp-Apim-Subscription-Key': 'MF_OCP'
				}
			let	config={
				url: this.clientPanNo.url,
					updateList:['VID','Ocp-Apim-Subscription-Key']
				}
		return  this.sendReqTOServer(params, config, obj);
	}

	public getTradeListing(cookievalue: any, tradeListPrams: any) {
		let params =  {"head": {"RequestCode": "TradeListing","Key": "VerifyRequestApi","AppName": this.tradeListing.appName,"AppVer": "1.0.4.0","OsName": "Android",
		"userType": this.commonService.get('userType')},"body": {"ClientCode": tradeListPrams.clientCode,"ReportType":tradeListPrams.ReportType ,"FromDate": tradeListPrams.fromDate,"ToDate": tradeListPrams.ToDate, "exchange":tradeListPrams.exch}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "AAA_OCP",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		let	config={
				url: this.tradeListing.url,
					updateList:['Key','Ocp-Apim-Subscription-Key']
				}
		return  this.sendReqTOServer(params, config, obj);
	}

	public getSettlementList(cookievalue: string, dataToPass: any) {
		const checkSumKey = this.ciphetText.generateCheckSumKey()
		const checkSumString = dataToPass.ClientCode + "_" + dataToPass.FromDate + "_" + dataToPass.ToDate + "_" + dataToPass.Exchange + "_" + checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
		dataToPass.ClientCode = this.ciphetText.createChecksum(dataToPass.ClientCode, checkSumKey)
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				 "Key": "VerifyRequestApi",
				  "AppName": this.settlement.appName, "AppVer": "01", "OsName": "Android",
				"CheckSum":checkSumString,
				"CheckSumKey":checkSumKey,
				"userType": this.commonService.get('userType')
			}, "body": dataToPass
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': "AAA_OCP",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		let	config={
				url: this.settlement.url,
					updateList:['Key','Ocp-Apim-Subscription-Key','CheckSum']
				}
		return  this.sendReqTOServer(params, config, obj);
	}

	public getUnrealizedPl(cookievalue: any, Objprams: any) {
		let params =  {"head": {"RequestCode": "PnLSummaryUnRealized","Key": "VerifyRequestApi","AppName": this.unRealizedPL.appName,"AppVer": "1.0.4.0","OsName": "Android",
		"userType": this.commonService.get('userType')},"body": {"ClientCode": Objprams.clientCode,"TillDate": Objprams.tillDate,"Product" : Objprams.product}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "AAA_OCP",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		let	config={
				url: this.unRealizedPL.url,
					updateList:['Key','Ocp-Apim-Subscription-Key']
				}
		return  this.sendReqTOServer(params, config, obj);

	}

	public getRealizedPl(cookievalue: any, realizedPlParams: any, env:any) {
		let stringValue = realizedPlParams.clientCode + "_" + moment(new Date()).format('DDMMYYYY');
		let params =  {
			"head": {
				"RequestCode": "PnLSummaryRealized",
				"Key": "VerifyRequestApi",
				"AppName": this.unRealizedPL.appName,
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"CheckSumKey": 'clientTrades',
    			"CheckSum": stringValue
			},
			"body": {
				"ClientCode": this.ciphetText.aesEncrypt(realizedPlParams.clientCode),
				"FromDate": realizedPlParams.fromDate,
				"ToDate":realizedPlParams.ToDate,
				"Product" : realizedPlParams.product, 
				"PartnerCode" : this.commonService.get("userId1") ? this.ciphetText.aesEncrypt(this.commonService.get("userId1")): "",
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "AAA_OCP",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		let	config={
				url: this.realizedPL.url,
				createWithCustomKey:true,
					updateList:['Key','Ocp-Apim-Subscription-Key','CheckSumKey','CheckSum']
				}
		return  this.sendReqTOServer(params, config, obj);

	}

	public getContractDownload(cookievalue: any, data: any) {
		let params =  {
			"head": {
				"RequestCode": "IIFLMarRPLedgerMail02",
				"Key": "marketParams",
				"AppVer": "1.0",
				"AppName": "IIFLMarkets",
				"OsName": "Android"
			},
			"body": {
				"Clientcode": data.ClientCode || data.Client,
				"ContractNoteType": data.type == "COM" ? "CommodityContractNotes" :"EquityContractNotes",
				"Date": data.Date ? data.Date : data.date,
				"Callfrom": "AAA"
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "eaccount",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		let	config={
				url: this.zentechContractNotes.url,
					updateList:['Key','Ocp-Apim-Subscription-Key']
				}
		return  this.sendReqTOServer(params, config, obj);

	}

	public sharedDownloadReport(cookievalue: any, passObj: any, reportType?: any) {
		let params: any =  passObj;
		let obj : any = {}
		obj = {
				 'Ocp-Apim-Subscription-Key' : "AAA_OCP",
				 'appID': this.commonService.get('appID') || ''
			};
		if (cookievalue) {
			obj.token = cookievalue;
		}
		let	config={
				url: this.downloadReport.url,
					updateList:['Key','Ocp-Apim-Subscription-Key']
				}
		return  this.sendReqTOServer(params, config, obj);
	}

	/**
	 * API call to download mf-account statement report.
	 * @param tokenValue 
	 * @param passObj 
	 * @returns 
	 */
	public downloadMfAccountReport(tokenValue: any, passObj: any) {
		let params: any = {
			"head":
			{
				"VID": "mfCommonVid",
				"AppName": "Website",
				"AppVersion": "",
				"userType": this.commonService.get('userType'),
				"Key": this.env.verifyGuestandExtendedApi.key,
			},
			"body": passObj
		}
		let obj: any = {};
		if (tokenValue) {
			obj = {
				'token': tokenValue,
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' ,
				'Ocp-Apim-Subscription-Key' : "MF_OCP",
				'appID': this.commonService.get('appID') || ''
			}
		}
		let	config={
				url: this.mfReport.url,
					updateList:['Key','Ocp-Apim-Subscription-Key',"Authorization"]
				}
		return  this.sendReqTOServer(params, config, obj);
	}

	public getCommodityrealtimereport(cookievalue: any,id: any) {
		let params: any = {
			"head":
			{
				"RequestCode": "CVUpdateLead01",
				"Key": "Verify_Guest_And_ExtendedApi",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"Clientcode": id
			}
		}
		let obj = {
			'Ocp-Apim-Subscription-Key' : "AAA_OCP",
			'token' : cookievalue,
			'appID': this.commonService.get('appID') || ''
		};
		let	config={
				url: this.commodityrealtimereport.url,
					updateList:['Key','Ocp-Apim-Subscription-Key']
				}
		return  this.sendReqTOServer(params, config, obj);
	}

	public getDPHoldingStatement(cookievalue:any, objPrams:any) {
		let params =  {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "Verify_Guest_And_ExtendedApi",
				"AppName": this.dpHoldingStatement.appName,
				"AppVer": "01",
       		    "OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"DPID": objPrams.DPID,
				"AsOnDate": objPrams.AsOnDate,
				"DPType" : objPrams.DPType
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "AAA_OCP",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		let	config={
				url: this.dpHoldingStatement.url,
					updateList:['Key','Ocp-Apim-Subscription-Key']
				}
		return  this.sendReqTOServer(params, config, obj);
	}
	public getMFRejectionData(cookievalue: any, payload: any) {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "Verify_Guest_And_ExtendedApi",
				"AppName": "AAA",
				"AppVer": "1.0.4.0",
				"OsName": "Android"
			},
			"body":payload
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': "AAA_OCP",
			'appID': this.commonService.get('appID') || ''
		};
		const usersType = payload.LoginID[0] === 'C' ? '1' : '2';
		if (cookievalue) obj['token'] = cookievalue;
		let	config={
				url: this.mfRejectionData.url,
				//`${this.mfRejectionData.url}?User_Id=${payload.LoginID}&User_Type=${usersType}&FromDate=${payload.FromDate}&ToDate=${payload.ToDate}`,
					updateList:['Key','Ocp-Apim-Subscription-Key']
				}
		return  this.sendReqTOServer(params, config, obj);
	}
	
	public ExchangeCertificateReport(cookievalue: any, passObj: any, reportType?: any) {
		let checkSumKey = this.ciphetText.generateCheckSumKey()
		let stringValue = `${passObj.FanCode}_${passObj.Exchange}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		// const checkSumValue = this.ciphetText.createChecksum(stringValue,this.globalCheckSumkey);
		const patnerCode = this.ciphetText.createChecksum(passObj.FanCode ,checkSumKey);
		let params: any = {
			"head":
			{
				"RequestCode": 'exchangeCertificateDownload',
				"Key":"Verify_Guest_And_ExtendedApi",
				"AppName": this.ExchangeCertificate.AppName,
				"AppVer":this.ExchangeCertificate.AppVer,
				"OsName": this.ExchangeCertificate.OsName,
				"CheckSum" : stringValue,
				"CheckSumKey" :checkSumKey ,
			},
			"body" : {
				"FanCode" : patnerCode,
				"Exchange" : passObj.Exchange
		    }
	    }
		let obj : any = {}
		obj = {
				 'Ocp-Apim-Subscription-Key' : "AAA_OCP",
				 'appID': this.commonService.get('appID') || ''
			};
		if (cookievalue) {
			obj.token = cookievalue;
		}
		let	config={
				url: `${this.ExchangeCertificate.url}`,
					updateList:['Key','Ocp-Apim-Subscription-Key','CheckSum']
				}
		return  this.sendReqTOServer(params, config, obj);
	}

	getToken(env?:any): Observable<any> {
		let stringValue = '9845485454451454|' + moment(new Date()).format('DDMMYY')
		// Partner code is prepended server-side (see /api/secure/share-service-get-Active-Token
		// in server.ts) so it isn't shipped in the browser bundle.
		const body = {
			"Data": stringValue,
			"AppSource": this.userActivationToken.appSource,	
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key':  'modification_sub_key',
			'appID': localStorage.getItem('appID') || ''
		};
		let url=this.userActivationToken.url
		return this.httpClient.post('/api/secure/share-service-get-Active-Token', {
			body,obj,url
		},{ responseType: 'text' })
		// return  this.sendReqTOServer(params, config, obj);
	  }

	public getModificationStatus(cookievalue:any, objPrams:any) {
		// let IPAddress : any = this.commonService.get('ipAddressData') ? (JSON.parse(this.commonService.get('ipAddressData') || '{}').ClientIP) : this.env.userActivationandModificationStatusParams.IPAddress
		// let stringValue = objPrams.clientCode + objPrams.fromDate + objPrams.toDate + this.modificationStatus.appSource + IPAddress + moment(new Date()).format('DDMMYY')
		// // let CheckSumValue = this.ciphetText.generateCheckSumforuserActivation(this.env.userActivationandModificationStatusParams.MerchantKey , stringValue)
		// let params =  {
		// 	"head": {
		// 		"AppSource" : this.ciphetText.encryptStringAES(this.modificationStatus.appSource),
		// 		"IPAddress" : this.ciphetText.encryptStringAES(IPAddress),
		// 		"CheckSumValue" :  stringValue,
				
		// 	},
		// 	"body": {
		// 		"clientCode":  this.ciphetText.encryptStringAES(objPrams.clientCode),
		// 		"fromDate":  this.ciphetText.encryptStringAES(objPrams.fromDate),
		// 		"toDate" :  this.ciphetText.encryptStringAES(objPrams.toDate)
		// 	}
		// }
		// let obj: any = {
		// 	 'Ocp-Apim-Subscription-Key' : "userActivationOcpKey",
		// 	 'appID': this.commonService.get('appID') || '',
		// 	 'Authorization' : 'Bearer ' + cookievalue,
		// }

		// let	config={
		// 		url: `${this.modificationStatus.url}`,
		// 		customKey:true,
		// 		Key:'userActivationandModificationStatusParams_MerchantKey',
		// 			updateList:['Ocp-Apim-Subscription-Key','CheckSumValue']
		// 		}
		let IPAddress : any = localStorage.getItem('ipAddressData') ? (JSON.parse(localStorage.getItem('ipAddressData') || '{}').ClientIP) : this.env.userActivationandModificationStatusParams.IPAddress
		let stringValue = objPrams.clientCode + objPrams.fromDate + objPrams.toDate + this.modificationStatus.appSource + IPAddress + moment(new Date()).format('DDMMYY')
		// let CheckSumValue = this.ciphetText.generateCheckSumforuserActivation(this.env.userActivationandModificationStatusParams.MerchantKey , stringValue)
		// AppSource/IPAddress/clientCode/fromDate/toDate are encrypted server-side by the
		// /api/secure/share-service-get-Active-status route (see server.ts) before being
		// forwarded upstream — previously done here with a hardcoded key via encryptStringAES.
		let params =  {
			"head": {
				"AppSource" : this.modificationStatus.appSource,
				"IPAddress" : IPAddress,
				"CheckSumValue" :  stringValue,

			},
			"body": {
				"clientCode":  objPrams.clientCode,
				"fromDate":  objPrams.fromDate,
				"toDate" :  objPrams.toDate
			}
		}
		let obj: any = {
			 'Ocp-Apim-Subscription-Key' : 'modification_sub_key',
			 'appID': localStorage.getItem('appID') || '',
			 'Authorization' : 'Bearer ' + cookievalue,
		}
		let url=this.modificationStatus.url
		return this.httpClient.post('/api/secure/share-service-get-Active-status', {
			params,obj,url
		})
		// return  this.sendReqTOServer(params, config, obj);
	}

	sendReqTOServer(params:any,config:any,reqHead:any): Observable<{}>{ 
			return this.httpClient.post('/api/secure/common-all-service', {
				params,
				config,
				reqHead
			})
		}

	sendReqTOServerGet(params:any,config:any,reqHead:any): Observable<{}>{ 
		return this.httpClient.post('/api/secure/common-all-service-get', {
			params,
			config,
			reqHead
		})
	}
}









